import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { HomeComponent } from './shared/home/home.component';
import { FooterComponent } from './shared/footer/footer.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';
import { AosService } from './services/aos.service';
import { ROUTE_SEO_DATA } from './core/seo-data';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,NavbarComponent,FooterComponent,CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'kalpitaRevamp';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private aos: AosService
  ) {}

  ngOnInit() {
    // Scroll animations are owned here, once, for the whole app. See
    // `AosService` for why they can't be initialised per page (BUG_001).
    this.aos.init();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // The new page's [data-aos] elements are different nodes to the last
      // page's, so AOS has to re-collect them on every navigation.
      this.aos.refresh();

      // Traverse active route tree to get leaf route data
      let route = this.activatedRoute.root;
      while (route.firstChild) {
        route = route.firstChild;
      }
      
      const routeData = route.snapshot.data;
      const SITE = 'https://www.kalpitatechnologies.com';
      // Self-referential canonical for the actual served URL — used whenever the
      // route/SEO data doesn't supply an explicit one, so every page gets a
      // canonical that matches its own URL.
      const currentUrl = event.urlAfterRedirects.split('?')[0]; // remove query params
      const fallbackCanonical = SITE + currentUrl;

      if (routeData && (routeData['title'] || routeData['description'])) {
        this.seoService.updateAll({
          title: routeData['title'],
          description: routeData['description'],
          keywords: routeData['keywords'],
          canonical: routeData['url'] || routeData['canonical'] || fallbackCanonical,
          image: routeData['image'],
          ogTitle: routeData['ogTitle'],
          ogDescription: routeData['ogDescription'],
          // Only intentionally-noindexed routes (e.g. /csat) set this; every
          // other route leaves it undefined and updateAll() clears the tag.
          robots: routeData['robots']
        });
      } else {
        // Fallback to ROUTE_SEO_DATA database
        const seoConfig = ROUTE_SEO_DATA[currentUrl];

        if (seoConfig) {
          this.seoService.updateAll({
            title: seoConfig.title,
            description: seoConfig.description,
            canonical: seoConfig.path ? (SITE + seoConfig.path) : fallbackCanonical
          });
        } else {
          // No SEO data at all — still emit a self-referential canonical, and
          // make sure no stale robots meta survives from a previous route.
          this.seoService.updateCanonical(fallbackCanonical);
          this.seoService.updateRobots();
        }
      }
    });
  }
}
